import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resources-page',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
